import script from "./index4.vue?vue&type=script&setup=true&lang=js"
export * from "./index4.vue?vue&type=script&setup=true&lang=js"

import "./index4.vue?vue&type=style&index=0&id=3f5a1d81&lang=less&scoped=true"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f5a1d81"]])

export default __exports__